// tslint:disable:max-line-length

import React from 'react';

export const UtilityHelp = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M9.1,13.8H6.9v-2.1h2.1V13.8z M9.9,8.3L9.8,8.4C9.3,8.8,9,9,9,9.8 v0.7H7V9.8c0-1.7,1-2.6,1.6-3.1l0.1-0.1c0.5-0.5,0.8-0.7,0.8-1.5c0-0.2-0.1-0.4-0.2-0.5C9.1,4.5,8.8,4.3,8,4.3c-1,0-1.2,0.3-1.3,0.5 c-0.2,0.3-0.2,0.8-0.2,1v0.4H4.5V5.8c0-0.4,0-1.2,0.4-2c0.6-1,1.7-1.5,3.1-1.5c1.1,0,2,0.3,2.6,0.9c0.6,0.5,0.9,1.3,0.9,2 C11.5,6.9,10.5,7.8,9.9,8.3z" />
    </svg>
  );
};
